// false count – just need the highest form of plural
//  - see https://www.i18next.com/translation-function/plurals
export const T_PLURAL_COUNT = { count: 100 };
export const T_SINGULAR_COUNT = { count: 1 };
